import styled from 'styled-components'

export const CoachingHeaderTitle = styled.div`
  font-size: 24px;
  font-weight: 500;
`

export const ExplainationWrapper = styled.div`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
  `}
`

export const CoachingTitle = styled.div`
  /* padding-top: 24px; */
  font-size: 20px;
  font-weight: 500;
  line-height: 23px;
`

export const CoachingExplanation = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 23px;
  padding-top: 8px;
  text-align: justify;
`

export const ButtonWrap = styled.div`
  margin-left: 16px;
  transition: all 0.15s ease-in-out;
  &:active {
    transform: scale(0.95);
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-top: 8px;
    margin-left: auto;
  `}
`
export const CoachingButton = styled.div`
  width: 128px;
  background-color: #522ba4;
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 3%;
  line-height: 21px;
  outline: none;
  padding: 8px 10px;
  text-align: center;
`

export const CoachingWrapper = styled.div`
  align-items: center;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  margin: 16px 0;
  padding: 24px 28px;
  position: relative;
  transition: opacity 0.35s ease-in-out;

  ${ButtonWrap} {
    opacity: 0;
    transition: opacity 0.35s;
  }

  &:before {
    background: linear-gradient(91.85deg, #522ba4 2.46%, #d06cff 100.14%);
    border-radius: 8px;
    bottom: 0;
    content: '';
    left: 0;
    opacity: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: opacity 0.35s;
    z-index: -1;
  }

  &:hover {
    ${ButtonWrap} {
      opacity: 1;
    }

    &:before {
      opacity: 1;
    }
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-direction: column;
  `}
`
